import { spacesToHyphens } from '@core/helpers'

// Format bytes to adapted unit depending on the value.
export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'

  const kilobyte = 1000
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const sizesIndex = Math.floor(Math.log(bytes) / Math.log(kilobyte))

  return `${parseFloat((bytes / kilobyte ** sizesIndex).toFixed(dm))} ${
    sizes[sizesIndex]
  }`
}

// Groups data structure by a specific attributes
export const groupBy = (arr, attributeName) =>
  arr
    .map((val) => val[attributeName])
    .reduce(
      (acc, val, i) => ({ ...acc, [val]: (acc[val] || []).concat(arr[i]) }),
      {},
    )

export const slugifyProduct = (prettyProduct) => {
  const doubleUnderscore = prettyProduct.replace(/_/g, '__')
  const hyphensToUnderscore = doubleUnderscore.replace(/-/g, '_')
  const withHyphens = spacesToHyphens(hyphensToUnderscore)
  const toLowercaseName = withHyphens.toLowerCase()

  return toLowercaseName
}
